import { render, staticRenderFns } from "./ReportingVideos.vue?vue&type=template&id=51928445&scoped=true&"
import script from "./ReportingVideos.vue?vue&type=script&lang=js&"
export * from "./ReportingVideos.vue?vue&type=script&lang=js&"
import style0 from "./ReportingVideos.vue?vue&type=style&index=0&id=51928445&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51928445",
  null
  
)

export default component.exports